import { useCallback } from 'react'

import { constants } from 'helpers'
import useAuthDispatch from './useAuthDispatch'

const {
  AUTH_ACTIONS: { LOGOUT },
} = constants

const useLogin = () => {
  const dispatch = useAuthDispatch()

  const logout = useCallback(() => {
    localStorage.clear()
    dispatch({ type: LOGOUT })
  }, [dispatch])

  return logout
}

export default useLogin
